import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { computeStep } from "../utils/computeStep";
import { useMetaByPathConfig } from "./useMetaByPathConfig";

export const useGetComputedRoute = () => {
  const location = useLocation();
  const attemptingRoute = location.pathname;
  const { handleSetOnboarding, ...onboarding } = useOnboarding();
  const user = useCurrentUser();
  const { externalId } = user || {};
  const { metaByPath, questionnaireOrder } = useMetaByPathConfig();

  const computedStep = useMemo(() => {
    return computeStep({
      attemptingRoute,
      onboarding,
      isAuthenticated: !!externalId,
      metaByPath,
      questionnaireOrder,
    });
  }, [attemptingRoute, onboarding, externalId, metaByPath, questionnaireOrder]);

  return computedStep;
};
